export default __webpack_public_path__ + "static/media/Home Page.cfbbb012.png";